import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// 1. ellipsis - V
// 2. add ellipsis props - V
// 3. add design - V
// 4. add design props - V
// 3. pass all possible props to ellipsis wrapper - V
// 5. add responsive deign - V
// 6. set api table with proper description - V
// 7. set default props values - V
// 5. add validation on design props with fallback and default values - V
// 6. add disabled design and review all props in Zeplin spec to make sure we are all covered - V
// 7. add storybook examples - V
// 5. add playground props - V
// 9. add deprecation message in the HeadingLabel component - V
// 6. add visual tests - V
// 8. do all this list again for for Heading
// 10. ask for ux approval
// 11. pass lint locally
// 3. check for warnings
// 10. check for warnings in all modified code
// 11. add to backlog 2 new tasks - 1. migrating headingLabel usages. 2. modify component font changes by Zohar's list

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TooltipOnEllipsis from '../tooltipOnEllipsis/tooltipOnEllipsis';
import { dataHooks } from './constants';
var validValues = {
  appearances: {
    options: ['h1', 'h2', 'h3', 'h4', 'h5'],
    defaultValue: 'h1'
  }
};

// const ellipsisPropsNames = [
//     'closeOnMouseClick',
//     'contentClassName',
//     'customTrigger',
//     'customTooltipMessage',
//     'displayCustomTrigger',
//     'marginTop',
//     'marginLeft'
// ]
var Heading = /*#__PURE__*/function (_React$PureComponent) {
  function Heading(props) {
    var _this;
    _classCallCheck(this, Heading);
    _this = _callSuper(this, Heading, [props]);
    _this.getValidAppearance = function (appearanceRaw) {
      var appearance = appearanceRaw.toLowerCase();
      return validValues.appearances.options.includes(appearance) ? appearance : validValues.appearances.defaultValue;
    };
    return _this;
  }
  _inherits(Heading, _React$PureComponent);
  return _createClass(Heading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        light = _this$props.light,
        dataHook = _this$props.dataHook,
        appearance = _this$props.appearance,
        translateIfNeeded = _this$props.translateIfNeeded,
        multiline = _this$props.multiline,
        getClassName = _this$props.getClassName;
      var validAppearance = this.getValidAppearance(appearance);
      var lighterColor = light ? 'light' : '';
      var content = translateIfNeeded(children);
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: classNames(getClassName('control-heading'), validAppearance, lighterColor)
      }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
        dataHook: dataHooks.text,
        maxLines: multiline ? 999 : 1
      }, content));
    }
  }]);
}(React.PureComponent);
Heading.displayName = displayNames.HEADING;
Heading.propTypes = {
  /** The actual text to be rendered */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Font size of the heading */
  appearance: PropTypes.oneOf(validValues.appearances.options),
  /** Set heading with lighter color - effect `standard` and `secondary` skins only */
  light: PropTypes.bool,
  /** Allow multiline heading*/
  multiline: PropTypes.bool
};
Heading.defaultProps = {
  dataHook: 'Heading',
  appearance: validValues.appearances.defaultValue,
  light: false,
  multiline: false
};
export default compose(Heading);